"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const address_1 = __importDefault(require("../address"));
const portalCountriesConfig_1 = __importDefault(require("./portalCountriesConfig"));
const portalInsuranceConfig_1 = __importDefault(require("./portalInsuranceConfig"));
const portalInvoiceConfig_1 = __importDefault(require("./portalInvoiceConfig"));
const portalLegalConfig_1 = __importDefault(require("./portalLegalConfig"));
const portalLogos_1 = __importDefault(require("./portalLogos"));
class PortalConfiguration {
    constructor(shortName, name, purchaseCertificateSendingEmail, isWhitelabel, address, insurance, logos, invoice, countries, legal, defaultCoverageId, wkwEmail, allowQuebecPickUp, allowOceanCargoProduct, annualProductsRegion, portalPrefix, shareContacts, defaultPolicyHolderName) {
        this.shortName = shortName;
        this.name = name;
        this.purchaseCertificateSendingEmail = purchaseCertificateSendingEmail;
        this.isWhitelabel = isWhitelabel;
        this.address = address;
        this.insurance = insurance;
        this.logos = logos;
        this.invoice = invoice;
        this.countries = countries;
        this.legal = legal;
        this.defaultCoverageId = defaultCoverageId;
        this.wkwEmail = wkwEmail;
        this.allowQuebecPickUp = allowQuebecPickUp;
        this.allowOceanCargoProduct = allowOceanCargoProduct;
        this.annualProductsRegion = annualProductsRegion;
        this.portalPrefix = portalPrefix;
        this.shareContacts = shareContacts;
        this.defaultPolicyHolderName = defaultPolicyHolderName;
    }
    static fromObj(data) {
        var _a, _b;
        if (!data) {
            throw new Error("Portal config is not loaded successfully.");
        }
        return new PortalConfiguration(data.shortName, data.name, data.purchaseCertificateSendingEmail, !!data.isWhitelabel, address_1.default.fromObj(data.address), portalInsuranceConfig_1.default.fromObj(data.insurance), portalLogos_1.default.fromObj(data.logos), portalInvoiceConfig_1.default.fromObj(data.invoice), portalCountriesConfig_1.default.fromObj(data.countries), portalLegalConfig_1.default.fromObj(data.legal), (_a = data.defaultCoverageId) !== null && _a !== void 0 ? _a : "", data.wkwEmail, data.allowQuebecPickUp, data.allowOceanCargoProduct, data.annualProductsRegion, data.portalPrefix, (_b = data.shareContacts) !== null && _b !== void 0 ? _b : false, data.defaultPolicyHolderName);
    }
}
exports.default = PortalConfiguration;
//# sourceMappingURL=portalConfiguration.class.js.map